<main class="template-mapping-popup">
  <nb-card *ngIf="templateGroupsFrom">
    <nb-card-header><h4>{{ templateFrom.header }} => {{ templateTo.header }}</h4></nb-card-header>
    <nb-card-body>
      <form [formGroup]="form">
        <div *ngFor="let group of templateGroupsFrom" class="templateGroup__item">
          <div class="templateGroup__item-header">
            {{ group.header }}
          </div>
          <div class="templateGroup__features">
            <div class="templateGroup__features-item row" *ngFor="let feature of group.features;" [formGroupName]="feature.id.toString()">
              <div class="col-sm-6">{{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span><span class="featureType">({{ feature.featureTypeHeader }})</span></div>
              <div class="col-sm-6">
                <ng-select [items]="filterAvailableFeatures(feature)"
                           formControlName="destFeatureId"
                           bindLabel="header"
                           bindValue="id"
                           [clearable]="true"
                           (change)="selectFeature($event, feature)"
                           placeholder="Выберите характеристику"
                           i18n-placeholder="@@ChooseTemplateFeaturePlaceholder"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.header }} ({{ item.groupHeader }}) ({{ item.featureTypeHeader }})
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.header }} ({{ item.groupHeader }}) ({{ item.featureTypeHeader }})
                  </ng-template>
                </ng-select>
                <div *ngIf="isSelectableFeatureType(feature.featureTypeId) && form.get(feature.id.toString()).value?.destFeatureId" style="margin: 10px 0">
                  <a class="pointer" i18n="@@SetFeatureValueMappingButton" (click)="setFeatureValueMapping(feature)">Настроить значения свойств</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="primary" type="button" i18n="@@Save" [disabled]="form.invalid" (click)="saveTemplateMapping()">Сохранить</button>&nbsp;
      <button nbButton status="basic" type="button" i18n="@@Close" (click)="modalClose()">Закрыть</button>
    </nb-card-footer>
  </nb-card>
</main>
